// extracted by mini-css-extract-plugin
module.exports = {"container":"JQ","modal":"KQ"};